import { Spacing, Title } from '@vkontakte/vkui';
import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { cancelImageGeneration } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { getAiGenerationImagePercentage } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.selectors';
import { Button, ButtonVariant } from 'reactApp/ui/Button/Button';

import styles from './FullScreenAiPhotoGenerationLoader.css';

export const FullScreenAiPhotoGenerationLoader = memo(function FullScreenAiPhotoGenerationLoader() {
    const percentage = useSelector(getAiGenerationImagePercentage);
    const dispatch = useDispatch();

    const stopGenerationButtonClick = useCallback(() => {
        dispatch(cancelImageGeneration());
    }, [dispatch]);

    return (
        <>
            <img className={styles.lottie} src={`${cdnPackagesUrl}/static/cloud/ai/photo-generation/loader/loader.gif`} />
            <div className={styles.container}>
                <Title className={styles.percentage}>{percentage}%</Title>
                <Spacing size={24} />
                <Title className={styles.title}>Точим цифровой карандашик</Title>
                <Spacing size={8} />
                <span className={styles.text}>Изображение генерируется</span>
                <Spacing size={96} />
                <Button onClick={stopGenerationButtonClick} className={styles.button} size="medium" variant={ButtonVariant.contrast}>
                    Остановить генерацию
                </Button>
            </div>
        </>
    );
});
